import React from 'react';
import PropTypes from 'prop-types';
import Link, { LINK_BEHAVIORS, LINK_SIZES } from 'components/Link';
import LinkListItem from './LinkListItem';
import cn from 'classnames';

import './LinkList.scss';

const LinkList = ({ items }) => {
  return items && items.length > 0 ? (
    <div className="link-list">
      <nav className="link-list__nav">
        <ul className="link-list__items">
          {items.map((item, index) => {
            return (
              <li className="link-list__item" key={index}>
                {item.isActive ? (
                  <span className="link-list__item-text">{item.text}</span>
                ) : (
                  <Link
                    {...item}
                    size={LINK_SIZES.large}
                    behavior={LINK_BEHAVIORS.text}
                    className={cn('link-list__link', {
                      'link-list__link_active': item.isActive,
                    })}
                  />
                )}
              </li>
            );
          })}
        </ul>
      </nav>
    </div>
  ) : null;
};

LinkList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.exact(LinkListItem.propTypes)).isRequired,
};

export default LinkList;
